<script>
  // import { Sortable, Plugins } from "@shopify/draggable"; // Не работает в ИЕ 11
  // import SwapAnimation from '@shopify/draggable/lib/plugins/swap-animation'; // Не работает в ИЕ 11
  import { Sortable, Plugins } from '@shopify/draggable/lib/es5/draggable.bundle.legacy.js';

  function move(items, oldIndex, newIndex) {
    const itemRemovedArray = [
      ...items.slice(0, oldIndex),
      ...items.slice(oldIndex + 1, items.length)
    ];
    return [
      ...itemRemovedArray.slice(0, newIndex),
      items[oldIndex],
      ...itemRemovedArray.slice(newIndex, itemRemovedArray.length)
    ];
  }

  export default {
    name: 'VsortableList',

    provide() {
      return {
        itemClass: this.itemClass,
        handleClass: this.handleClass
      };
    },

    props: {
      value: {
        required: true
      },

      itemClass: {
        type: String,
        default: 'sortable-item'
      },

      handleClass: {
        type: String,
        default: 'sortable-handle'
      },

      has_animation: {
        type: Boolean,
        default: true
      }
    },

    mounted() {
      let options = {
        draggable: `.${this.itemClass}`,
        handle: `.${this.handleClass}`,
        mirror: {
          constrainDimensions: true
        }
      };

      if (this.has_animation) {
        options = Object.assign({}, options, {
          swapAnimation: {
            duration: 150,
            easingFunction: 'linear',
            vertical: true
          },
          plugins: [Plugins.SwapAnimation]
        });
      }
      new Sortable(this.$el, options)
        .on('sortable:start', () => {
          this.$emit('start');
        })
        .on('sortable:stop', ({ oldIndex, newIndex }) => {
          this.$emit('stop');
          this.$emit('input', move(this.value, oldIndex, newIndex));
        });
    },

    render() {
      return this.$scopedSlots.default({
        items: this.value
      });
    }
  };
</script>
